import { useMainStore } from "../stores/store"

//useDataLogic()
export function useDataLogic() {
    const config = useRuntimeConfig()
    const SERVER_URI = config.public.backendUrlExt

    async function fetchSources() {
        const store = useMainStore()

        //Pražský uličník data
        store.dataPU = await $fetch<PuData[]>("select-heslo-all", {
            baseURL: SERVER_URI,
        }).catch(error => error.data)

        store.sourceReady = true
    }

    // async function fetchSourcesSouborneHeslo() {
    //     const store = useMainStore()

    //     //Pražský uličník data Souborné heslo
    //     store.dataSouborneHeslo = await $fetch<PuData[]>(
    //         "https://pulicnik.geoportalpraha.cz/backend/select-souborne-heslo-all"
    //     ).catch(error => error.data)

    //     store.sourceReady = true
    // }

    //get All Streets
    // function getAllStreets() {
    //     const store = useMainStore()

    //     return store.data
    // }

    function serverUri() {
        return SERVER_URI
    }

    return {
        fetchSources,
        // fetchSourcesSouborneHeslo,
        // getAllStreets,
        serverUri,
    }
}
